import React from 'react'
import { imageList } from '../configs/images-config';
//AVCDAAV.002  22/03/2025  Add code for  Adding Loading component
type Props = {
    centered: boolean
    size: "smallest" |"small" | "medium" | "large";
    witoutBottombar?: boolean;
}

export const Loading = (props: Props) => {
    return (
        <div className={`loading-container 
                ${props.centered ? 'center' : ''} 
                ${props.witoutBottombar ? 'without-bottombar' : 'with-bottombar'} 
                ${props.size}`}
        >
            <img src={imageList.loading_image} alt="loading" className={`image-loading ${props.size}`}/>
        </div>
    )
}

//C-AVCDAAV.002  22/03/2025  Add code for  Adding Loading component
